import { render } from "./TripsView.vue?vue&type=template&id=8502b028"
import script from "./TripsView.vue?vue&type=script&lang=js"
export * from "./TripsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__